import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("[ErrorBoundary] Unhandled render error:", error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleHome = () => {
    window.location.href = "/";
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div
        dir="rtl"
        lang="he"
        className="min-h-screen flex items-center justify-center px-4 bg-background"
      >
        <div className="max-w-md w-full text-center rounded-2xl p-8 bg-card border border-border shadow-sm">
          <div className="mx-auto mb-4 w-12 h-12 rounded-full flex items-center justify-center bg-destructive/10 text-destructive text-2xl font-bold">
            !
          </div>
          <h1 className="text-xl font-bold mb-2 text-primary">
            אירעה שגיאה לא צפויה
          </h1>
          <p className="text-sm mb-6 text-muted-foreground">
            הנתונים שמילאת לא אבדו. אפשר לרענן את הדף ולהמשיך מהמקום שעצרת.
          </p>
          <div className="flex flex-col gap-2">
            <button
              onClick={this.handleReload}
              className="w-full rounded-lg py-2.5 text-white bg-primary hover:bg-primary-hover font-medium transition-colors"
            >
              רענן את הדף
            </button>
            <button
              onClick={this.handleHome}
              className="w-full rounded-lg py-2.5 bg-background text-primary border border-border font-medium hover:bg-secondary/40 transition-colors"
            >
              חזרה לדף הבית
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
